import { render, staticRenderFns } from "./SrPlanEnvAssessmentEdit.vue?vue&type=template&id=bb5c4bde&"
import script from "./SrPlanEnvAssessmentEdit.vue?vue&type=script&lang=js&"
export * from "./SrPlanEnvAssessmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports